export default __webpack_public_path__ + "static/media/location.2553fc45.svg";